module.exports = __webpack_public_path__ + "assets/img/202111-1.ea9ed899.png";